<template>
  <v-container class="listContainer">
    <self-building-square-spinner
      :animation-duration="6000"
      :size="40"
      color="#3498db"
      style="margin: 0 auto"
    />
  </v-container>
</template>

<script>
import { SelfBuildingSquareSpinner } from 'epic-spinners';

export default {
  name: 'Loader',
  components: {
    SelfBuildingSquareSpinner,
  },
};
</script>
